import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
  export default new Vuex.Store({
    state: {
      // 要回显的数据
      imgUrl:'http://hbagthyy.com/webpic/',// https://hbrsyyyxgs.com http://www.shenhaoyaoye.com http://xiangzhiyaoye.com  http://ysxyygs.com/元氏 http://hbqsyy.cn
      logoImg:'http://hbagthyy.com/',
      companyID:10,//神豪5 荣顺12 祥芝10 元氏25
      lunboList:[],
      gongsijianjie:'',
      gongsipic:'',
      productList:[],
      companypic:{},
      companyName:'河北翼祥药业有限公司', //荣顺饮片 
      quanming:'河北翼祥药业有限公司',
      appName:'翼祥药业',
      logo:'',
      footerInfo:{},
      addresscoordinate:'',
      guanyuwomen:''
    },
    getters: {
    },
    mutations: {
      CHANGE_imgUrl: (state, imgUrl) => state.imgUrl =imgUrl,
      CHANGE_logoImg: (state, logoImg) => state.logoImg =logoImg,
        CHANGE_ADDRESSCOORDINATE: (state, addresscoordinate) => state.addresscoordinate = addresscoordinate,
      CHANGE_LUNboList: (state, lunbolist) => state.lunboList = lunbolist,
      CHANGE_LOGO: (state, logo) => state.logo =logo,
      
      CHANGE_GONGSIJIANJIE: (state, JIANJIE) => state.gongsijianjie = JIANJIE,
      CHANGE_GONGSIPIC: (state, gongsipic) => state.gongsipic = gongsipic,
      CHANGE_PRODUCTLIST: (state, productList) => state.productList = productList,
      CHANGE_COMPANYPIC: (state, companypic) => state.companypic = companypic,
      CHANGE_footerInfo: (state, footerInfo) => state.footerInfo = footerInfo,
        CHANGE_guanyuwomen: (state, guanyuwomen) => state.guanyuwomen = guanyuwomen,
    },
    actions: {
    },
    modules: {
    }
  })




// WEBPACK FOOTER //
// ./src/store/index.js